const accountTypes = () => {
  return {
    user: 1,
    merchent: 2,
    employee: 3
  };
};

export default accountTypes;
